import Image from "next/image";

import { Artist, Instrument } from "@/types/types";
import { getSizesString } from "@/utils/getSizesString";

export function ShowImageArtistInstrument({
  artistInstrument,
}: {
  artistInstrument: Artist | Instrument;
}) {
  return (
    <div className="aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-3xl">
      <Image
        src={artistInstrument.image}
        alt={`Image of AI singer ${artistInstrument.name}`}
        className="object-cover"
        fill={true}
        sizes={getSizesString({
          sm: 100,
          md: 100,
          lg: 50,
          rest: 33,
        })}
      />
    </div>
  );
}
